// extracted by mini-css-extract-plugin
module.exports = {"label":"_e8600a"};